import { X } from "lucide-react";
import { GetImageUrl } from "../../../helpers/GetImageUrl";
import { memo } from "react";

const ProjectImageSection = ({ images, setImages }) => {
  return (
    <div className="space-y-5">
      <div className="flex justify-between items-center">
        <h4 className="text-sm text-slate-300">Project Images</h4>

        <label
          className={`px-4 py-2 rounded-xl border text-xs cursor-pointer ${
            (images?.new?.length ?? 0) >= 20
              ? "opacity-40 cursor-not-allowed border-white/10"
              : "bg-blue-500/10 border-blue-500/30 text-blue-400"
          }`}
        >
          + Upload
          <input
            hidden
            type="file"
            multiple
            accept="image/*"
            disabled={images?.new?.length >= 20}
            onChange={(e) => {
              const files = Array.from(e.target.files);
              const remaining = 20 - (images?.new?.length ?? 0);
              const allowedFiles = files
                .filter((file) => {
                  if (file.size > 20 * 1024 * 1024) {
                    toast.error(`${file.name} is bigger than 20MB`);
                    return false;
                  }

                  return true;
                })
                .slice(0, remaining);

              const newImages = allowedFiles.map((file) => ({
                file,
                preview: URL.createObjectURL(file),
                alt: "",
                caption: "",
              }));
              setImages((prev) => ({
                ...prev,
                new: [...(prev.new || []), ...newImages],
              }));
              e.target.value = "";
            }}
          />
        </label>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-5">
        {images?.existing?.map((img, index) => (
          <div
            key={index}
            className="rounded-xl bg-white/5 border border-white/10 p-3"
          >
            <div className="relative">
              <img
                src={GetImageUrl(img.url)}
                className="h-32 w-full object-cover rounded-lg opacity-70"
              />

              <button
                type="button"
                onClick={() => {
                  setImages((prev) => ({
                    ...prev,
                    removed: [
                      ...prev.removed,
                      {
                        id: img._id,
                        url: img.url,
                      },
                    ],

                    existing: prev.existing.filter((_, i) => i !== index),
                  }));
                }}
                className="absolute top-1 right-1 bg-red-500 rounded-full p-1 "
              >
                <X size={12} />
              </button>
            </div>

            <input
              value={img.alt}
              placeholder="Image Alt"
              onChange={(e) => {
                const copy = [...images.existing];
                copy[index] = {
                  ...copy[index],
                  alt: e.target.value,
                };

                setImages((prev) => ({
                  ...prev,
                  existing: copy,
                }));
              }}
              className="mt-2 w-full h-8 px-2 text-xs rounded-lg bg-black/40 border border-white/10 text-white"
            />
            <input
              value={img.caption}
              placeholder="Image Caption"
              onChange={(e) => {
                const copy = [...images.existing];
                copy[index] = {
                  ...copy[index],
                  caption: e.target.value,
                };

                setImages((prev) => ({
                  ...prev,
                  existing: copy,
                }));
              }}
              className="mt-2 w-full h-8 px-2 text-xs rounded-lg bg-black/40 border border-white/10 text-white"
            />
          </div>
        ))}

        {images?.new?.map((img, index) => (
          <div
            className="rounded-xl bg-white/5 border border-blue-500/30 p-3"
            key={index}
          >
            <div className="relative">
              <img
                src={GetImageUrl(img.preview)}
                className="h-32 w-full object-cover rounded-lg"
              />
              <button
                type="button"
                onClick={() => {
                  URL.revokeObjectURL(images.new[index].preview);
                  setImages((prev) => ({
                    ...prev,
                    new: prev.new.filter((_, i) => i !== index),
                  }));
                }}
                className="absolute top-1 right-1 bg-red-500 rounded-full p-1 "
              >
                <X size={12} />
              </button>
            </div>
            <input
              placeholder="Image Alt"
              value={img.alt}
              onChange={(e) => {
                const copy = [...images.new];
                copy[index] = {
                  ...copy[index],
                  alt: e.target.value,
                };
                setImages((prev) => ({
                  ...prev,
                  new: copy,
                }));
              }}
              className="          mt-2
          w-full
          h-8
          px-2
          text-xs
          rounded-lg
          bg-black/40
          border border-white/10
          text-white "
            />

            <input
              placeholder="Image Caption"
              value={img?.caption}
              onChange={(e) => {
                const copy = [...images.new];
                copy[index] = {
                  ...copy[index],
                  caption: e.target.value,
                };

                setImages((prev) => ({
                  ...prev,
                  new: copy,
                }));
              }}
              className="mt-2 w-full
            h-8 px-2 text-xs rounded-lg bg-black/40 border border-white/10 text-white
            "
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(ProjectImageSection);
